module.exports = __webpack_public_path__ + "img/shutterstock_59887279.057ba051.jpg";